// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/FormasPagamento_DeletarResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /config/formas_pagamento/deletar
 *
 * Returned on the success path of Formas_pagamento::deletar(). The legacy
 * shape was `dados: { forma_pagamento_id: <int> }` — preserved here as
 * a typed object response (default getDados()).
 *
 * Failure paths use $this->sendError('...') in the controller.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface FormasPagamento_DeletarResponseDados {
forma_pagamento_id?: number
}

export type FormasPagamento_DeletarResponse = ApiResponse<FormasPagamento_DeletarResponseDados>;

registerResponseContract('FormasPagamento_DeletarResponse', {
  forma_pagamento_id: { type: 'number',  required: false },
})
